import { render, staticRenderFns } from "./IndexValues.vue?vue&type=template&id=7f39d575&"
import script from "./IndexValues.vue?vue&type=script&lang=js&"
export * from "./IndexValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports